import {Component} from '@angular/core';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap';
import {ModalFields} from '../../models/modal-fields';
import {Field} from '../../models/crud/Field';
import {Config} from '../../models/crud/Config';
import {AngularFireDatabase} from 'angularfire2/database';
import {TimeTrackerService} from '../time-tracker-service.service';
import {User} from '../../models/User';
import {MatSnackBar} from '@angular/material';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-userprofile-modal',
    template: `
        <div class="modal-header">
            <h4 class="modal-title pull-left">{{_model.config.title | translate}}</h4>
            <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="container-form small row">
                <div class="input-group fullWith col-12">
                    <mat-form-field class="fullWith">
                        <input matInput type="text"
                               maxlength="50"
                               [(ngModel)]="user.username" [required]="true"
                               [placeholder]="'MODEL.USER.USERNAME'|translate"/>
                    </mat-form-field>
                </div>

                <div class="input-group fullWith col-6">
                    <mat-form-field class="fullWith">
                        <input matInput type="text"
                               maxlength="30"
                               [(ngModel)]="user.ci" [required]="true"
                               [placeholder]="'MODEL.USER.CI'|translate"/>
                    </mat-form-field>
                </div>

                <div class="input-group fullWith col-6">
                    <mat-form-field class="fullWith">
                        <input matInput type="text"
                               [(ngModel)]="user.email" [required]="true"
                               [disabled]="user.id"
                               maxlength="30"
                               [placeholder]="'MODEL.USER.EMAIL'|translate"/>
                    </mat-form-field>
                </div>

                <mat-form-field class="fullWith col-6">
                    <mat-select
                        [placeholder]="'MODEL.USER.USER_TYPE'|translate"
                        [(ngModel)]="user.userType"
                        [required]="true">
                        <mat-option *ngFor="let option of userTypeEntries" [value]="option.key">
                            {{option.value | translate}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="fullWith col-6">
                    <mat-select
                        [placeholder]="'MODEL.USER.TEAM'|translate"
                        [(ngModel)]="user.teamId"
                        [required]="true">
                        <mat-option *ngFor="let team of teams" [value]="team.id">{{team.name}}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="fullWith col-6" *ngIf="isToCreateNewUser">
                    <input matInput type="password" [placeholder]="'MODEL.USER.PASSWORD'|translate"
                           [(ngModel)]="password" maxlength="30" [required]="true"/>
                </mat-form-field>

                <div class="fullWith col-12">
                    <mat-checkbox class="mV10 fullWith"
                                  [(ngModel)]="user.active">{{'MODEL.USER.ACTIVE' | translate}}
                    </mat-checkbox>
                </div>

                <!--  <div *ngFor="let field of _model.fields" class="input-group fullWith {{field.class||'col-12'}}">
                      <ng-container *ngIf="!field.hidden" class="row">
                          <div *ngIf="field.type == 'image'" class="fullWith">
                              <img [src]="field.value" width="90" height="90"
                                   onerror="this.src='https://firebasestorage.googleapis.com/v0/b/time-tracker-82e5f.appspot.com/o/empty_team.png?alt=media&token=079e49b9-234d-4a8b-8d25-62a9c5db89f6';this.onerror=null">
                              <input class="small" type="file" accept="image/jpeg,image/png"
                                     [ngModel]="field.valueTemp"
                                     (change)="readUrl($event, field)"/>
                          </div>
                      </ng-container>
                  </div>-->
            </div>
        </div>
        <div class="modal-footer">
            <button mat-raised-button type="button" (click)="bsModalRef.hide()">
                {{_model.config.cancelLabel | translate}}
            </button>

            <ng-container *ngIf="user.id">
                <button mat-raised-button color="accent" type="button" (click)="update()"
                        [disabled]="disableBtnUpdate">
                    {{'MODEL.USER.EDIT_USER' | translate}}
                </button>
            </ng-container>

            <ng-container *ngIf="!user.id">
                <button mat-raised-button color="accent" type="button" (click)="create()"
                        [disabled]="disableBtnCreate">
                    {{'MODEL.USER.CREATE_USER' | translate}}
                </button>
            </ng-container>
        </div>
    `,
    providers: [BsModalService]
})

export class UserProfileModalComponent {
    user: User = new User();
    isToCreateNewUser: boolean = false;
    password: string = '';
    _companyId: string = '';
    userTypeEntries = [
        {key: 'PENDING', value: 'USER_TYPES.PENDING'},
        {key: 'PLANT_WORKER', value: 'USER_TYPES.PLANT_WORKER'},
        {key: 'INTERN', value: 'USER_TYPES.INTERN'},
        {key: 'EXTERNAL', value: 'USER_TYPES.EXTERNAL'}
    ];

    public _model: ModalFields;

    private disableBtnCreate;
    private disableBtnUpdate;
    private disableBtnDelete;

    public teams;

    constructor(public bsModalRef: BsModalRef, public af: AngularFireDatabase, public tts: TimeTrackerService,
                public snackBar: MatSnackBar, public ts: TranslateService) {
        this._model = new ModalFields(
            [],
            new Config('Time Tracker'),
            false, false, false
        );
        this.disableBtnCreate = false;
        this.disableBtnUpdate = false;
        this.disableBtnDelete = false;
    }

    public setUser(user: User, companyId) {
        this._companyId = companyId;
        console.log('set User', user);
        if (user) {
            this.isToCreateNewUser = false;
            this.user = user;
        } else {
            this.isToCreateNewUser = true;
            this.user = new User();
            this.user.companyId = this._companyId;
        }

        // this._model.fields
        // this.af.list(TimeTrackerService.USERS+ '/' +user.id)
        this.tts.getTeamsFromCompany(this._companyId, teams => {
            this.teams = teams;
        });
    }

    public validate(): boolean {
        if (!this.user.username) return false;
        if (!this.user.ci) return false;
        if (!this.user.email) return false;
        if (this.isToCreateNewUser) {
            if (!this.password || this.password.length < 4) {
                return false;
            }
        }
        return true;
    }

    /**
     * Create New User, automatically signOut current session after register
     */
    public create() {
        if (!this.validate()) {
            this.ts.get('PLEASE_SET_VALID_DATA').subscribe(str => {
                    this.snackBar.open(str, null, {duration: 2000});
                }
            );
            return;
        }
        console.log('Click to create', this.user);
        let object: User = new User();
        object.id = this.guid();
        object.username = this.user.username;
        object.email = this.user.email;
        object.photoUrl = this.user.photoUrl || '';
        object.ci = this.user.ci;
        object.userType = this.user.userType;
        object.companyId = this._companyId;
        object.teamId = this.user.teamId;
        object.active = this.user.active || false;
        object.isAdmin = this.user.isAdmin || false;
        if (this.isToCreateNewUser) {
            object.password = this.password;
        }
        this.disableBtnCreate = true;

        // this.af.app.auth().createUserAndRetrieveDataWithEmailAndPassword()
        this.af.app.auth()
            .createUserWithEmailAndPassword(object.email, object.password)
            .then(userFire => {
                object.id = userFire.uid;
                console.log('success', userFire);
                this.af.database.ref(TimeTrackerService.USERS + '/' + object.id)
                    .update(object)
                    .then(success => {
                        this.af.app.auth().signOut();
                    }, failed => {
                        console.log('failed', failed);
                    });
                this.bsModalRef.hide();
                this.disableBtnCreate = false;
            })
            .catch(error => {
                console.log('error', error);
                this.disableBtnCreate = false;

                this.ts.get('MODEL.USER.CANT_CREATE_USER').subscribe((res: string) => {
                    this.snackBar.open(res, null, {duration: 1500});
                });
            });
    }

    public update() {
        if (!this.validate()) {
            this.ts.get('PLEASE_SET_VALID_DATA').subscribe(str => {
                    this.snackBar.open(str, null, {duration: 2000});
                }
            );
            return;
        }

        console.log('Click to edit', this.user);
        let object: User = new User();
        object.id = this.user.id;
        object.username = this.user.username;
        object.email = this.user.email;
        object.photoUrl = this.user.photoUrl || '';
        object.ci = this.user.ci;
        object.userType = this.user.userType;
        object.companyId = this.user.companyId;
        object.teamId = this.user.teamId;
        object.active = this.user.active || false;
        object.isAdmin = this.user.isAdmin || false;
        this.disableBtnUpdate = true;
        this.af.database.ref(TimeTrackerService.USERS + '/' + object.id)
            .update(object);
        this.bsModalRef.hide();
    }

    /**
     * Function to preview image file
     * @param event
     * @param {Field} field
     */
    readUrl(event: any, field: Field) {
        if (event.target.files && event.target.files[0]) {
            let reader = new FileReader();
            reader.onload = (event: any) => {
                field.value = event.target.result;
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    private guid() {
        function _p8(s) {
            let p = (Math.random().toString(16) + '000000000').substr(2, 8);
            return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
        }

        return _p8(false) + _p8(true) + _p8(true) + _p8(false);
    }
}



// WEBPACK FOOTER //
// ./src/app/modals/userprofile-modal.ts